var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.499V24C0 24.5523 0.447715 25 0.999999 25H3.09165C3.62339 25 4.04795 24.577 4.17286 24.0602C5.02321 20.5414 9.44022 21.0845 10.0839 23.8842C10.2178 24.4664 10.6621 25 11.2595 25H25.7829C26.2769 25 26.6848 24.633 26.8386 24.1634C27.8827 20.9757 31.6562 21.0332 32.6295 23.5261C32.8456 24.0796 33.3663 24.5313 33.9533 24.4384L37.1563 23.9315C37.6422 23.8546 38 23.4358 38 22.9438V20.7916C38 20.4731 37.8154 20.1834 37.5267 20.0488C37.2546 19.9219 37.0737 19.6564 37.0551 19.3568L36.9135 17.0759C36.8813 16.5575 36.4577 16.1501 35.9385 16.1381L32.1745 16.0511C31.9485 16.0458 31.7329 15.9634 31.5542 15.825C26.4499 11.8735 16.2043 11.9991 9.48655 16.6335C9.31438 16.7523 9.11222 16.8162 8.90336 16.8274C6.69671 16.9458 3.23483 18.2124 1.27901 19.0417C0.916451 19.1955 0.686058 19.5534 0.686058 19.9472V20.4358C0.686058 20.665 0.551861 20.873 0.343029 20.9674C0.134197 21.0618 0 21.2698 0 21.499Z",
    fill: "#D6E3FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1499 17.9815H13.7435C13.3102 17.9815 12.959 17.6303 12.959 17.197C12.959 16.9801 13.0475 16.771 13.2128 16.6306C14.7547 15.3202 16.7384 14.7682 18.3067 14.5828C19.348 14.4597 20.1031 15.4082 19.9429 16.4444C19.8061 17.3289 19.0448 17.9815 18.1499 17.9815Z",
    fill: "#3081F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6157 17.9815H23.9092C22.8509 17.9815 22.0133 17.0865 22.0833 16.0306C22.141 15.1588 22.8101 14.4423 23.6833 14.4726C25.1919 14.5248 26.7302 14.8639 26.9851 15.2672C27.1057 15.4581 27.2136 15.7867 27.2958 16.1664C27.5145 17.1776 26.6502 17.9815 25.6157 17.9815Z",
    fill: "#3081F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/body.6c40bdfd5db47cd17a212d6bd6d05308.svg";
export { ForwardRef as ReactComponent };